'use strict';
import $ = require("jquery");
import Seminar   from './_seminar';

$(() => {
    // 会員登録
    new Seminar.MySeminar();
});